import type { toAwinSaleObject } from './browser-sale';
import { parseAwinAdvertiserId } from './config';

declare global {
  interface Window {
    AWIN?: {
      Tracking?: {
        Sale?: ReturnType<typeof toAwinSaleObject>;
        run?: () => void;
      };
    };
  }
}

let loadedAdvertiserId: string | null = null;
let loading: Promise<void> | null = null;

/** One program per document; loading the public tag never initializes a Sale. */
export function loadAwinMasterTag(advertiserId: string, nonce: string): Promise<void> {
  if (!parseAwinAdvertiserId(advertiserId))
    return Promise.reject(new Error('Invalid Awin advertiser'));
  if (loadedAdvertiserId && loadedAdvertiserId !== advertiserId) {
    return Promise.reject(new Error('Awin advertiser cannot change within a document'));
  }
  if (loading) return loading;
  loadedAdvertiserId = advertiserId;
  loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = 'awin-mastertag';
    script.src = `https://www.dwin1.com/${advertiserId}.js`;
    script.defer = true;
    script.nonce = nonce;
    const cleanup = () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };
    const onLoad = () => {
      cleanup();
      resolve();
    };
    const onError = () => {
      cleanup();
      reject(new Error('Awin MasterTag could not load'));
    };
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    try {
      document.head.appendChild(script);
    } catch {
      onError();
    }
  });
  return loading;
}
